import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import VideoPlayers from "./videoPlayers";

export default class SwiperSliders {
    constructor() {
        this.videoPlayers = new VideoPlayers();
        this.init();
    }

    init() {
        this.initSwiperCarousel1();
        this.initSwiperCarousel2();
        this.initSwiperCarousel3();
        this.initSwiperCarousel5();

        this.initSwiperListing5();

        this.initSwiperTestimonials1();
        this.initSwiperTestimonials2();
        this.initSwiperTestimonials4();

        this.initSwiperCarouselProjet();
    }

    // === SWIPER CAROUSEL 1 ===
    initSwiperCarousel1() {
        const swiperCarousel1 = document.querySelector('.swiperCarousel-1');
        if( swiperCarousel1 ) {
            new Swiper(".swiperCarousel-1", {
                grabCursor: true,
                slidesPerView: 1.125,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2.25,
                    },
                    1024: {
                        slidesPerView: 3.125,
                    },
                    1200: {
                        slidesPerView: 3.5,
                    },
                },
                navigation: {
                    prevEl: ".block-carousel-1 .swiper-navigation .swiper-prev",
                    nextEl: ".block-carousel-1 .swiper-navigation .swiper-next",
                },
            });
        }
    }

    // === SWIPER CAROUSEL 2 ===
    initSwiperCarousel2() {
        const swiperCarousel2 = document.querySelector('.swiperCarousel-2');
        if( swiperCarousel2 ) {
            new Swiper(".swiperCarousel-2", {
                grabCursor: true,
                slidesPerView: 1.125,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2.25,
                    },
                    1024: {
                        slidesPerView: 3.125,
                    },
                    1200: {
                        slidesPerView: 3.5,
                    },
                },
                navigation: {
                    prevEl: ".block-carousel-2 .swiper-navigation .swiper-prev",
                    nextEl: ".block-carousel-2 .swiper-navigation .swiper-next",
                },
            });
        }
    }

    // === SWIPER CAROUSEL 3 ===
    initSwiperCarousel3() {
        const swiperCarousel3 = document.querySelector('.swiperCarousel-3');
        if( swiperCarousel3 ) {
            new Swiper(".swiperCarousel-3", {
                grabCursor: true,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 14,
                loop: true,
                navigation: {
                    prevEl: ".block-carousel-3 .swiper-navigation .swiper-prev",
                    nextEl: ".block-carousel-3 .swiper-navigation .swiper-next",
                },
                on: {
                    slideChange: () => {
                        this.pauseCurrentVideo();
                    }
                }
            });
        }
    }

    // === SWIPER CAROUSEL 5 ===
    initSwiperCarousel5() {
        const swiperCarousel5 = document.querySelector('.swiperCarousel-5');
        if( swiperCarousel5 ) {
            new Swiper(".swiperCarousel-5", {
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
                navigation: {
                    prevEl: ".block-carousel-5 .swiper-navigation .swiper-prev",
                    nextEl: ".block-carousel-5 .swiper-navigation .swiper-next",
                },
            });
        }
    }

    // === SWIPER LISTING 5 ===
    initSwiperListing5() {
        const swiperListing5 = document.querySelector('.swiperListing-5');
        if( swiperListing5 ) {
            new Swiper(".swiperListing-5", {
                grabCursor: true,
                slidesPerView: 'auto',
                spaceBetween: 14,
                loop: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20,
                    },
                    1024: {
                        spaceBetween: 40,
                    },
                },
                navigation: {
                    prevEl: ".block-listing-5 .swiper-navigation .swiper-prev",
                    nextEl: ".block-listing-5 .swiper-navigation .swiper-next",
                },
            });
        }
    }


    // === SWIPER TESTIMONIALS 1 ===
    initSwiperTestimonials1() {
        const swiperTestimonials1 = document.querySelector('.swiperTestimonials-1');
        if( swiperTestimonials1 ) {
            new Swiper(".swiperTestimonials-1", {
                grabCursor: true,
                slidesPerView:"auto",
                spaceBetween: 14,
                centeredSlides: true,
                maxBackfaceHiddenSlides: 5,
                loop: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20
                    },
                    1024: {
                        spaceBetween: 40
                    },
                    1200: {
                        spaceBetween: 80
                    },
                },
                navigation: {
                    prevEl: ".block-testimonials-1 .swiper-navigation .swiper-prev",
                    nextEl: ".block-testimonials-1 .swiper-navigation .swiper-next",
                },
            });
        }
    }

    // === SWIPER TESTIMONIALS 2 ===
    initSwiperTestimonials2() {
        const swiperTestimonials2 = document.querySelector('.swiperTestimonials-2');
        if( swiperTestimonials2 ) {
            new Swiper(".swiperTestimonials-2", {
                grabCursor: true,
                slidesPerView:"auto",
                spaceBetween: 14,
                centeredSlides: true,
                loop: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20
                    },
                    1024: {
                        spaceBetween: 40
                    },
                    1200: {
                        spaceBetween: 80
                    },
                },
                navigation: {
                    prevEl: ".block-testimonials-2 .swiper-navigation .swiper-prev",
                    nextEl: ".block-testimonials-2 .swiper-navigation .swiper-next",
                },
            });
        }
    }

    // === SWIPER TESTIMONIALS 4 ===
    initSwiperTestimonials4() {
        const swiperTestimonials4TextElement = document.querySelector('.swiperTestimonials-4-text');
        const swiperTestimonials4MediaElement = document.querySelector('.swiperTestimonials-4-media');
        const paginationElement = document.querySelector('.block-testimonials-4 .swiper-pagination-numeric');

        if (swiperTestimonials4TextElement && swiperTestimonials4MediaElement) {
            const mediaSwiper = new Swiper(swiperTestimonials4MediaElement, {
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                watchSlidesProgress: true,
                grabCursor: true,
                allowTouchMove: false,
                simulateTouch: false,
                on: {
                    slideChange: () => {
                        this.pauseCurrentVideo();
                    }
                }
            });

            const textSwiper = new Swiper(swiperTestimonials4TextElement, {
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                grabCursor: true,
                navigation: {
                    nextEl: ".block-testimonials-4 .swiper-navigation .swiper-next",
                    prevEl: ".block-testimonials-4 .swiper-navigation .swiper-prev",
                },
                thumbs: {
                    swiper: mediaSwiper,
                },
            });

            const totalSlides = parseInt(paginationElement.getAttribute('data-total-slides'), 10);

            function updatePagination() {
                const currentIndex = textSwiper.realIndex + 1;
                paginationElement.textContent = `${currentIndex} / ${totalSlides}`;
            }

            textSwiper.on('init', updatePagination);
            textSwiper.on('slideChange', updatePagination);
        }
    }

    // === SWIPER CAROUSEL PROJET ===
    initSwiperCarouselProjet() {
        const swiperCarouselProjet = document.querySelector('.swiperCarousel-projet');
        if( swiperCarouselProjet ) {
            new Swiper(".swiperCarousel-projet", {
                grabCursor: true,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 14,
                loop: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                navigation: {
                    prevEl: ".block-carousel-projet-a2w .swiper-navigation .swiper-prev",
                    nextEl: ".block-carousel-projet-a2w .swiper-navigation .swiper-next",
                },
                on: {
                    slideChange: () => {
                        this.pauseCurrentVideo();
                    }
                }
            });
        }
    }

    pauseCurrentVideo = () => {
        if (this.videoPlayers) {
            this.videoPlayers.pauseAllPlayers();
        }
    };

}